import React, { useState } from "react";
import axios from "axios";
import { MdEdit, MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import EditCategories from "./EditCategories";

const TableCategories = ({ categories, fetchCategories }) => {
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [showDeletePrompt, setShowDeletePrompt] = useState(false);
  const [deleteCategoryId, setDeleteCategoryId] = useState(null);

  const handleEditClick = (id) => {
    setSelectedCategoryId(id);
    setShowEditPopup(true);
  };

  const handleDeleteClick = (id) => {
    setDeleteCategoryId(id);
    setShowDeletePrompt(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await axios.delete(`/api_w/postcategories/${deleteCategoryId}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          db_name: process.env.REACT_APP_DB_NAME,
        },
      });
      toast.success("Berhasil Hapus Kategori!");
      fetchCategories();
    } catch (error) {
      toast.error(
        "Error Hapus Kategori: " +
          (error.response?.data?.message || error.message)
      );
    } finally {
      setShowDeletePrompt(false);
    }
  };

  return (
    <div>
      {/* Count Badge */}
      <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
        <p className="text-sm text-gray-500">
          Total <span className="font-bold text-navy-700">{categories.length}</span> kategori
        </p>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-100">
            <tr>
              <th className="px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-400">No</th>
              <th className="px-5 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-400">Nama Kategori</th>
              <th className="px-5 py-3 text-center text-xs font-semibold uppercase tracking-wider text-gray-400">Aksi</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {categories.length === 0 ? (
              <tr>
                <td colSpan={3} className="py-12 text-center text-sm text-gray-400">
                  Belum ada kategori.
                </td>
              </tr>
            ) : (
              categories.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50/80 transition-colors">
                  <td className="whitespace-nowrap px-5 py-4 text-sm text-gray-500">{index + 1}</td>
                  <td className="px-5 py-4 text-sm font-medium text-navy-700">{item.name}</td>
                  <td className="px-5 py-4 text-center">
                    <div className="flex items-center justify-center gap-2">
                      <button
                        onClick={() => handleEditClick(item.id)}
                        className="flex h-8 w-8 items-center justify-center rounded-lg bg-blue-50 text-blue-500 transition-colors hover:bg-blue-100"
                      >
                        <MdEdit className="h-4 w-4" />
                      </button>
                      <button
                        onClick={() => handleDeleteClick(item.id)}
                        className="flex h-8 w-8 items-center justify-center rounded-lg bg-red-50 text-red-500 transition-colors hover:bg-red-100"
                      >
                        <MdDelete className="h-4 w-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {showEditPopup && (
        <EditCategories
          onClose={() => setShowEditPopup(false)}
          categoryId={selectedCategoryId}
          fetchCategories={fetchCategories}
        />
      )}

      {/* Delete Modal */}
      {showDeletePrompt && (
        <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/50">
          <div className="mx-4 w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl">
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-50">
              <MdDelete className="h-6 w-6 text-red-500" />
            </div>
            <h3 className="mb-2 text-lg font-bold text-navy-700">Hapus Kategori?</h3>
            <p className="mb-6 text-sm text-gray-500">Kategori yang dihapus tidak dapat dikembalikan.</p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowDeletePrompt(false)}
                className="rounded-xl border border-gray-200 px-5 py-2.5 text-sm font-semibold text-gray-600 hover:bg-gray-50 transition-colors"
              >
                Batal
              </button>
              <button
                onClick={handleConfirmDelete}
                className="rounded-xl bg-red-500 px-5 py-2.5 text-sm font-bold text-white hover:bg-red-600 transition-colors"
              >
                Hapus
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TableCategories;
